import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'


//import genQRCode from "@/views/genQRCode"

Vue.use(Router)

const originalPush = Router.prototype.push;
// 解决路由冗余保错
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

 const router = new Router({
  //mode: 'hash',
  // mode: 'history',
  routes
})


/* 2023-5-7 JOEN 去掉了这个登录检查，导致导致商户无法通过账单消息进入完成支付*/
router.beforeEach((to,from, next) => {
  console.log("beforEach",from ,to ,next)

  // 路由发送变化时修改页面title
  if(to.meta.title != undefined)
    document.title = to.meta.title;
  else
    document.title = "众敏经管云";

  let PID_INITED = sessionStorage.getItem("PID_INITED");

  if((to.meta.needLogin == true) && (PID_INITED == undefined) ){
    console.log('需要登录');
    next({
      path: '/',
      query: {
        fromPath: to.path,
        variables: JSON.stringify(to.query)
      }
    })
  }else{
    next();
  }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js